(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("chai"), require("sinon"), require("sinon-chai"), require("mocha"), require("../rc-sdk"));
	else if(typeof define === 'function' && define.amd)
		define(["chai", "sinon", "sinon-chai", "mocha", "../rc-sdk"], factory);
	else if(typeof exports === 'object')
		exports["RCSDK"] = factory(require("chai"), require("sinon"), require("sinon-chai"), require("mocha"), require("../rc-sdk"));
	else
		root["RCSDK"] = factory(root["chai"], root["sinon"], root["sinonChai"], root["mocha"], root["RCSDK"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_51__, __WEBPACK_EXTERNAL_MODULE_52__, __WEBPACK_EXTERNAL_MODULE_53__, __WEBPACK_EXTERNAL_MODULE_54__, __WEBPACK_EXTERNAL_MODULE_55__) {
return 


/** WEBPACK FOOTER **
 ** webpack/universalModuleDefinition
 **/